import { render, staticRenderFns } from "./CookieSetterPage.vue?vue&type=template&id=00c28abe&scoped=true&"
import script from "./CookieSetterPage.vue?vue&type=script&lang=js&"
export * from "./CookieSetterPage.vue?vue&type=script&lang=js&"
import style0 from "./CookieSetterPage.vue?vue&type=style&index=0&id=00c28abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c28abe",
  null
  
)

export default component.exports